import React, { FC, useEffect, useRef, useState } from "react";
import {
  Container,
  Header,
  TitleWrapper,
  ButtonsWrapper,
  ActionsRow,
  ActionsGroup,
  Subtitle,
  Body
} from './styles'
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, ClipBoardWrapper, Link, ModalVariables, NotificationBlock, ResourceBulkActions, Table, TableSkeleton, Tabs, TopProgress, Typography } from "../../../../../components";
import { objStorageService } from "../../../../../api";
import IcUpload from './import1.svg'
import Skeleton from "react-loading-skeleton";
import { useTheme } from "styled-components";
import { useUi } from "../../../../../context/ui.context";
import IcFolder from './folder-ic.svg'
import IcFile from './document-ic.svg'
import IcDownload from './import.svg'
import moment from 'moment'
import { formatFileSizeRounded, formatFileSize } from "../../../../../utils/sizes";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import Select from '../../../../../components/select';
import { icons } from "../../../../../icons";
import copy from 'copy-to-clipboard';
import { useAuth } from "../../../../../context/user.context";
import { extractErrorMessage } from "../../../../../utils/handleErrorFile";
import { compareArrays } from "../../../../../utils/findIntersection";
import { permissionSurfaces, usePermission, usePermissionDecision } from '../../../../../permissions';
interface FilesPage {
  files?:any
  updateFunc:() => void;
}

const Component:FC<FilesPage> = ({updateFunc}) => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const inputRef:any = useRef()
  const {user} = useAuth()
  const {viewAlert, updateAlertProgress} = useUi()
  const [queryPath, setQueryPath] = useQueryParam('path', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [localPageSize, setLocalPageSize] = useState<number>(pageSize || 10);
  const [cursor, setCursor] = useQueryParam('cursor', StringParam);
  const [loadingUpload, setLoadingUpload] = useState<boolean>(false)
  const [files, setFiles] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>()
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [loadingComplete, setLoadingComplete] = useState<boolean>(false)
  const [path, setPath] = useState<any>('')
  const [selectedFile, setSelectedFile] = useState<any>(null)
  const {bucketId} = useParams()
  const [checked, setChecked] = useState<any[]>([])
  const [allChecked, setAllChecked] = useState<boolean>(false)
  const [currentCursor, setCurrentCursor] = useState<string | null>(cursor || null)
  const [previousCursor, setPreviousCursor] = useState<string | null>(null)
  const [nextCursor, setNextCursor] = useState<string | null>(null)
  const [hasNextPage, setHasNextPage] = useState<boolean>(false)
  const [hasPreviousPage, setHasPreviousPage] = useState<boolean>(false)
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true)
  const [isUpdatingData, setIsUpdatingData] = useState<boolean>(false)
  const { mergeEntityPermissions } = usePermission()
  const canDeleteFiles = usePermissionDecision(permissionSurfaces.pageActions.objectStorageFilesDelete).allowed
  const canDeletePaths = usePermissionDecision(permissionSurfaces.pageActions.objectStoragePathsDelete).allowed
  const canAddFolder = usePermissionDecision(permissionSurfaces.pageActions.objectStorageAddFolder).allowed
  const canUploadFiles = usePermissionDecision(permissionSurfaces.pageActions.objectStorageUploadFile).allowed
  const canRetrieveFiles = usePermissionDecision(permissionSurfaces.pageActions.objectStorageFileRetrieve).allowed
  const canRetrievePaths = usePermissionDecision(permissionSurfaces.pageActions.objectStoragePathRetrieve).allowed

  const editChecked = (id:any, isAll?:boolean) => {
      if(id === null) {
        setChecked([])
        setAllChecked(false)
        return
      }
      const founded = checked.find((item:any) => item.id === id?.id)
      if(founded) {
        if(isAll){ 
          return 
        } else {
          setChecked((prev:any) => {
            return prev.filter((item:any) => item.id !== id?.id)
          })
          setAllChecked(false)
        }
      } else {
        setChecked((prev) => [...prev, id])
      }
    } 

  useEffect(() => {
    if(compareArrays(files, checked) && checked?.length !== 0){
      setAllChecked(true)
    }
  },[checked])

  const goUp = () => {
    // Убираем последний уровень директории
    const newPath = path.split('/').slice(0, -2).join('/') + '/';
    setPath(newPath);
    setQueryPath(newPath)
  };

  useEffect(() => {
    if(queryPath){
      setPath(queryPath)
    }
  },[queryPath])

  useEffect(() => {
    if(pageSize && pageSize !== localPageSize) {
      setLocalPageSize(pageSize)
    }
  },[pageSize])

  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }

  const closeModalCancel = () => {
    setViewModal(false)
    setModalType('')
    setActiveAnimation(false)
  }

  const getFiles = () => {
    //@ts-ignore
    objStorageService.getBucketFiles(bucketId, path||queryPath, localPageSize || 10, currentCursor)
    .then((res) => {
      mergeEntityPermissions('objectStorage', res.data, 'Merged bucket file permissions')
      setNextCursor(res.data.cursor)
      setHasNextPage(res.data.cursor !== null)
      setHasPreviousPage(currentCursor !== null)
      setFiles([
        ...(path && path !== '/'
          ? [
              {
                clear_name: (
                  <div onClick={goUp} style={{ display: 'flex',  gap: '6px', alignItems: 'center', cursor: 'pointer' }}>
                    <img src={IcFolder} alt="IcFolder" style={{ width: '16px' }} />
                    <Typography variant="body">...</Typography>
                  </div>
                ),
                
                hideProps:true
              },
            ]
          : []),
        ...res.data.folders.map((folder:any) => {
          const folderName = folder.Prefix.replace(res.data.prefix, '').replaceAll("/",'')
          return {
            clear_name: (
              <div onClick={() => {
                if (canRetrievePaths) {
                  setQueryPath(folder.Prefix)
                  setPath(folder.Prefix)
                }
              }} style={{display:'flex', gap:'6px', alignItems:"center", cursor:canRetrievePaths ? 'pointer' : 'default'}}>
                <img src={IcFolder} alt="IcFolder" style={{width:"16px"}} />
                <Typography customStyles={{wordBreak:"break-all",}}variant="body">{folderName}</Typography>
              </div>
            ),
            name:folder.Prefix,
            type:'folder',
            display_name:folderName,
            id:`${bucketId}/path/${folder.Prefix}`,
            // hideProps:true
            dropOptions:[
              {
                title:t("DELETE"),
                id:'7',
                permissionSurface: permissionSurfaces.rowActions.pathDelete,
                onClick:(file:any) => {
                  setAlertTitle(t("FILE"))
                  setAlertSubTitle([file])
                  setSelectedFile(file)
                  openModal('delete')
                },
                icon:icons.DeleteIcon,
                divider:false
              },
            ]
          }
        }),
        ...res.data.files.map((file:any) => {
          return {
            clear_name: (
              <div style={{display:'flex', gap:'6px', alignItems:"flex-start"}}>
                <img src={IcFile} alt="IcFile" style={{width:"16px", marginTop:'2px'}} />
                <Typography customStyles={{wordBreak:"break-all",}} variant="body">{file.Key.replace(res.data.prefix, '')}</Typography>
              </div>
            ),
            id:`${bucketId}/files/${file.Key}/`,
            name:file.Key,
            type:'file',
            last_modified: moment(file.LastModified).fromNow(),
            size:formatFileSize(file.Size),
            download:canRetrieveFiles ? (
              <div style={{cursor:'pointer'}} onClick={() => {
                if(bucketId){
                  objStorageService.getFileInfo(bucketId, file.Key)
                  .then((res:any) => {
                    window.location.href = res.data.Link
                  })
                  .catch((err:any) => {
                    viewAlert({
                      severity:'error',
                      message:err?.response?.data?.detail || `${t("ERROR_OCCURRED")}`
                    })
                  })
                }
              }}>
                <img src={IcDownload}/>
              </div>
            ) : null,
            storage_class:file.StorageClass,
          }
        })
      ])
      setTimeout(() => {
        setPageLoading(false)
        setIsInitialLoad(false)
        setIsUpdatingData(false)
      }, 300)
    })
    .catch((e) => {
      console.log('error', e);
      setPageLoading(false)
      setIsInitialLoad(false)
      setIsUpdatingData(false)
    })
  }

  useEffect(() => {
    setPageLoading(true)
    getFiles()
    const interval = setInterval(() => {
      getFiles()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[path, currentCursor, localPageSize])

  const theme:any = useTheme()
  
  if((pageLoading && isInitialLoad) || isUpdatingData) return (
    <Body>
      <TopProgress loading={pageLoading}/>
      <Skeleton
        baseColor={theme.palette[300]}
        highlightColor={theme.palette[20]}
        width={125} style={{marginBottom:"5px"}} height={30}
      />
      <TableSkeleton
        rows={10}
        columns={5}
      />
    </Body>
  )

  const ColumnsFiles = [
    {
      title:'Name',
      key:'clear_name'
    },
    {
      title:t("SIZE"),
      key:'size',
    },
    {
      title:t("LAST_MODIFIED"),
      key:'last_modified'
    },
    {
      title:t("STORAGE_CLASS"),
      key:'storage_class'
    },
    {
      title:'',
      key:'download'
    },
    {
      title:'',
      key:'props'
    },
  ]
  
  const props = [
    {
      title:t("MORE_INFO"),
      id:'1',
      icon:icons.Info,
      permissionSurface: permissionSurfaces.rowActions.fileDetails,
      onClick: (file:any) => {
        setSelectedFile(file)
        openModal('more-bucket-info')
      },
      divider:false
    },
    {
      title:t("VISIBILITY"),
      id:'2',
      icon:icons.EyeIc,
      permissionSurface: permissionSurfaces.rowActions.fileVisibility,
      onClick: (file:any) => {
        openModal('bucket-visibility')
        setSelectedFile(file)
      },
      divider:false
    },
    {
      title:t("OBJECT_METADATA"),
      id:'3',
      icon:icons.DocumentCodeIc,
      permissionSurface: permissionSurfaces.rowActions.fileMetadata,
      onClick: (file:any) => {
        setSelectedFile(file)
        openModal('bucket-metadata')
      },
      divider:false
    },
    {
      title:t("OBJECT_TAGS"),
      id:'4',
      icon:icons.CodeCircleIc,
      permissionSurface: permissionSurfaces.rowActions.fileTags,
      onClick: (file:any) => {
        setSelectedFile(file)
        openModal('bucket-file-tags')
      },
      divider:false
    },
    {
      title:t("EDIT_NAME"),
      id:'5',
      icon:icons.Edit,
      permissionSurface: permissionSurfaces.rowActions.fileRename,
      onClick: (file:any) => {
        setSelectedFile(file)
        setAlertTitle(`${t("EDIT_NAME")} «${file.name}»`)
        openModal('rename')
      },
      divider:false
    },
    {
      title:t("GET_PUBLIC_LINK"),
      id:'6',
      icon:icons.ExportIc,
      permissionSurface: permissionSurfaces.rowActions.filePublicLink,
      onClick:async  (file:any) => {
        setSelectedFile(file)
        openModal('bucket-copy-filelink')
      },
      divider:false
    },
    {
      title:t("DELETE"),
      id:'7',
      permissionSurface: permissionSurfaces.rowActions.fileDelete,
      onClick:(file:any) => {
        openModal('delete')
        setAlertTitle(t("FILE"))
        setAlertSubTitle([file])
        setSelectedFile(file)
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]

  const handleUpload = async (e:any) => {
    const files = e.target.files
    if (files && files.length > 0 && bucketId) {
      await setLoadingUpload(true)
      
      // Create a single alert for all files
      const uploadAlert = viewAlert({
        severity:'file',
        message: `Uploading ${files.length} file(s)...`,
        canClose:false,
      });
      
      let successCount = 0;
      let errorCount = 0;
      
      // Upload files sequentially to avoid overwhelming the server
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        // Создаем FormData и добавляем файл и дополнительные данные
        const formData = new FormData();
        formData.append("name", file.name);
        if(path){
          formData.append("path", path.slice(0, -1));
        }
        formData.append("file", file);

        try {
          // Create individual progress handler for each file
          const fileProgressHandler = (id: any, progress: any) => {
            const overallProgress = Math.round(((i + progress / 100) / files.length) * 100);
            updateAlertProgress(uploadAlert, overallProgress);
          };

          // Отправка данных на сервер через API
          //@ts-ignore
          const response = await objStorageService.uploadFile(bucketId, formData, fileProgressHandler, uploadAlert, user?.user?.clients?.[0]?.id);
          successCount++;
        } catch (uploadError:any) {
          console.error(`Error uploading ${file.name}:`, uploadError);
          errorCount++;
          
          if (uploadError.response && uploadError.response.data) {
            const errorMessage = extractErrorMessage(uploadError.response.data);
            viewAlert({
              severity: 'error',
              message: `${file.name}: ${errorMessage}`,
            });
          } else {
            viewAlert({
              severity: 'error',
              message: `${file.name}: Network error or no response from the server`,
            });
          }
        }
        
        // Update overall progress
        const overallProgress = Math.round(((i + 1) / files.length) * 100);
        updateAlertProgress(uploadAlert, overallProgress);
      }
      
      // Show final result
      if (errorCount === 0) {
        updateAlertProgress(uploadAlert, 100);
        setTimeout(() => {
          viewAlert({
            severity: 'success',
            message: `Successfully uploaded ${successCount} file(s)`,
          });
        }, 500);
      } else if (successCount > 0) {
        viewAlert({
          severity: 'warning',
          message: `Uploaded ${successCount} file(s), ${errorCount} failed`,
        });
      }
      
      await setLoadingUpload(false)
    }
    e.target.value = ''
  }

  const goToNextPage = () => {
    if (hasNextPage && nextCursor) {
      setIsUpdatingData(true)
      setPreviousCursor(currentCursor)
      setCurrentCursor(nextCursor)
      setCursor(nextCursor)
    }
  }

  const goToPreviousPage = () => {
    if (hasPreviousPage && previousCursor !== null) {
      setIsUpdatingData(true)
      setCurrentCursor(previousCursor)
      setCursor(previousCursor)
      setPreviousCursor(null)
    } else if (hasPreviousPage) {
      setIsUpdatingData(true)
      setCurrentCursor(null)
      setCursor(undefined)
      setPreviousCursor(null)
    }
  }

  const handlePageSizeChange = (value: any) => {
    const newPageSize = value.id || value.value || value
    setIsUpdatingData(true)
    setPageSize(newPageSize)
    setLocalPageSize(newPageSize)
    setCurrentCursor(null)
    setCursor(undefined)
    setPreviousCursor(null)
    setIsInitialLoad(false)
  }

  const handleClick = () => {
    inputRef.current?.click();
  };

  const deleteFile = async () => {
    setLoading(true);
    try {
      if (selectedFile) {
        await objStorageService.deleteFile(selectedFile.id);
      }
      setLoadingComplete(true)
      updateFunc()
      getFiles()
      setTimeout(() => {
        setLoading(false)
        setLoadingComplete(false)
        setViewModal(false)
        setActiveAnimation(false)
        setModalType('')
      },1000)
    } catch (e:any) {
      if (e.response && e.response.data) {
        const errorMessage = extractErrorMessage(e.response.data);
        viewAlert({
          severity: 'error',
          message: errorMessage,
        });
        setLoading(false)
      } else {
        viewAlert({
          severity: 'error',
          message: 'Network error or no response from the server',
        });
        setLoading(false)
      }
    }
  }

  const closeModalDeleteChecked = async () => {
    setLoading(true)
    try{
      console.log('checked', checked);
      console.log('allChecked', allChecked);
      if(allChecked) {
        let promises:any[] = []
        await files.map((item:any) => {
          let promise = objStorageService.deleteFile(item.id);
          promises.push(promise)
        })
        await Promise.all(promises)
        await setAllChecked(false)
      } else if (checked?.length > 0){
        let promises:any[] = []
        await checked.map((item:any) => {
          let promise = objStorageService.deleteFile(item.id);
          promises.push(promise)
        })
        await Promise.all(promises)
        await setChecked([])
      } else if (selectedFile) {
        await objStorageService.deleteFile(selectedFile.id);
      }
    } catch (e:any) {
      if(e?.response?.data.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail,
        })
      }
      setPageLoading(false)
      setLoading(false)
    } finally {
      setLoadingComplete(true)
      updateFunc()
      getFiles()
      setTimeout(() => {
        setLoading(false)
        setLoadingComplete(false)
        setViewModal(false)
        setActiveAnimation(false)
        setModalType('')
      },1000)
    }
  }

  const closeModal = async (props?:any) => {
    let res:any;
    try {
      if(!bucketId) return;
      setLoading(true);
      switch (modalType) {
        case 'add-folder':
          res = await objStorageService.addFolder(bucketId, {name:`${path}${props?.name}`})
          if (res?.data?.detail) {
            viewAlert({
              severity: 'info',
              message: res.data?.detail,
            });
          }
          break;
        case 'rename':
          res = await objStorageService.updateFile(bucketId, selectedFile.name, props)
          if (res?.data?.detail) {
            viewAlert({
              severity: 'info',
              message: res.data?.detail,
            });
          }
          break;
        case 'bucket-visibility':
          res = await objStorageService.updateFile(bucketId, selectedFile.name, props)
          if (res?.data?.detail) {
            viewAlert({
              severity: 'info',
              message: res.data?.detail,
            });
          }
          break;
        case 'bucket-metadata':
          res = await objStorageService.updateFile(bucketId, selectedFile.name, props)
          if (res?.data?.detail) {
            viewAlert({
              severity: 'info',
              message: res.data?.detail,
            });
          }
          break;
        case 'bucket-file-tags':
          res = await objStorageService.updateFile(bucketId, selectedFile.name, props)
          if (res?.data?.detail) {
            viewAlert({
              severity: 'info',
              message: res.data?.detail,
            });
          }
          break;
        case 'delete':
          closeModalDeleteChecked()
          break; 
      }
      if(modalType !== 'delete'){
        setLoadingComplete(true)
        updateFunc()
        getFiles()
        setTimeout(() => {
          setLoading(false)
          setLoadingComplete(false)
          setViewModal(false)
          setActiveAnimation(false)
          setModalType('')
        },1000)
      }
    } catch (e: any) {
      console.log('e',e);
      if (e.response && e.response.data) {
        const errorMessage = extractErrorMessage(e.response.data);
        viewAlert({
          severity: 'error',
          message: errorMessage,
        });
      await setLoadingUpload(false)
      await setLoading(false)
      } else {
        viewAlert({
          severity: 'error',
          message: 'Network error or no response from the server',
        });
      await setLoadingUpload(false)
      await setLoading(false)
      }
    }
  }

  return(
    <Container>
      <Header>
        <TitleWrapper>
          <Subtitle>{t("FILES_PAGE_DESCRIPTION")}</Subtitle>
        </TitleWrapper>
        <ButtonsWrapper>
          {canDeleteFiles || canDeletePaths ?
          <ResourceBulkActions
            ariaLabel={t("SELECTED_ITEMS", {count:checked.length})}
            actions={[{
              id:'delete-files',
              label:t("DELETE"),
              icon:icons.DeleteIcon,
              onClick:() => {
                setAlertTitle(t("FILES"))
                setAlertSubTitle(allChecked ? files : checked)
                openModal('delete')
              },
              testId:'button-delete',
              disabled:(allChecked ? files : checked).length === 0 || !(allChecked ? files : checked).every((item:any) => item.type === 'folder' ? canDeletePaths : canDeleteFiles),
            }]}
          />
          : null}
          {canAddFolder ?
          <Button
            variant="stroke"
            size="display"
            customStyles={{whiteSpace:'nowrap'}}
            onClick={() => openModal('add-folder')}
            title={`+ ${t("ADD_FOLDER")}`}
          />
          : null}
          <input
            ref={inputRef} 
            style={{display:'none'}} 
            type='file' 
            id="file-input" 
            onChange={(e) => handleUpload(e)} 
            multiple={true}
          />
          {canUploadFiles ?
          <Button
            variant="primary"
            size="display"
            customStyles={{whiteSpace:'nowrap'}}
            onClick={handleClick}
            title={`${t("UPLOAD")}`}
            icon={IcUpload}
            loading={loadingUpload}
          />
          : null}
        </ButtonsWrapper>
      </Header>
      <Body>
        {files?.length > 0 ?
          <Table
            columns={ColumnsFiles}
            rows={files}
            hideOther
            allChecked={allChecked}
            setAllChecked={setAllChecked}
            checked={checked}
            setChecked={editChecked}
            settings={props}
            cardSelectionToolbar
          />
        :
          <Typography variant="body">
            {t("NO_FILES_YET")}
          </Typography>
        }
        
        {files?.length > 0 && (
          <ActionsRow>
            <ActionsGroup>
              {/* <Typography variant="body" customStyles={{ fontSize: '14px' }}>
                {t("PAGE_SIZE")}:
              </Typography> */}
              <Select
                isSmall={true}
                title=""
                data={[
                  { id: 10, label: '10' },
                  { id: 25, label: '25' },
                  { id: 50, label: '50' },
                  { id: 100, label: '100' }
                ]}
                selectedValue={localPageSize || 10}
                onChange={handlePageSizeChange}
                customStyles={{ width: '80px' }}
              />
            </ActionsGroup>
            
            <ActionsGroup>
              <Button
                variant="icon"
                size="display"
                onClick={goToPreviousPage}
                disabled={!hasPreviousPage}
                customStyles={{ 
                  opacity: hasPreviousPage ? 1 : 0.5,
                  cursor: hasPreviousPage ? 'pointer' : 'not-allowed'
                }}
              >
                <img src={icons.ArrowLeft} />
              </Button>
              
              {/* <Typography variant="body" customStyles={{ fontSize: '14px', minWidth: '100px', textAlign: 'center' }}>
                {currentCursor ? t("PAGE") : t("FIRST_PAGE")}
              </Typography> */}
              
              <Button
                variant="icon"
                size="display"
                onClick={goToNextPage}
                disabled={!hasNextPage}
                customStyles={{ 
                  opacity: hasNextPage ? 1 : 0.5,
                  cursor: hasNextPage ? 'pointer' : 'not-allowed'
                }}
              >
                <img src={icons.ArrowRight} />
              </Button>
            </ActionsGroup>
          </ActionsRow>
        )}
      </Body>
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        instance={{...selectedFile, bucketId:bucketId, isFileNameBucket:true}}
        loading={loading}
        loadingComplete={loadingComplete}
        alertSubTitle={alertSubTitle}
      />
    </Container>
  )
}

export default Component
